import { observer } from "mobx-react-lite";
import './ResultCard.scss';
import { publicUrl } from "../utils/url";
import { formatCurrency } from "../utils/Currency";
import Rating from "./Rating";
import { _t } from '../utils/Lang';

const ResultCard = observer(({ children }) => {
    return (
        <div className="ResultCard">
            <div className="ResultCard__photo">
                <img src={publicUrl('/assets/materac.jpg')} alt="" />
                <div className="ResultCard__badge">{_t('expert_choice')}</div>
            </div>
            <div className="ResultCard__body bg-lightgray">
                <div className="d-flex j-between mb-2">
                    <div className="ResultCard__title">Materac NOMO Pro</div>
                    <Rating>5.0</Rating>
                </div>
                <div className="ResultCard__description color-lightgray">Mistrzowska hybryda komfortu. Łączy głębokie odciążenie pianką Visco z precyzyjnym wsparciem sprężyn. Gwarancja wydajnej cyrkulacji powietrza.</div>
                <div className="ResultCard__price mt-2">{_t('from')} {formatCurrency(1999)}</div>
            </div>

        </div>
    );
});

ResultCard.displayName = 'ResultCard';
export { ResultCard }